const TTL_MS = 60 * 1000; // 1 minute
const inflight = new Map();
const fetchedAt = new Map();

const isFresh = ts => ts && Date.now() - ts < TTL_MS;

export const fetchEntityWithCache = async (
  cacheKey,
  fetchFn,
  { force = false } = {}
) => {
  const ts = fetchedAt.get(cacheKey);
  if (!force && isFresh(ts)) {
    // Return a dummy object with data if we have it in store? 
    // Actually the pattern suggests the store should be the source of truth
    // but the helper prevents redundant network calls.
    return inflight.get(cacheKey) || Promise.resolve({ data: [] });
  }

  const running = inflight.get(cacheKey);
  if (running) return running;

  const request = fetchFn()
    .finally(() => {
      inflight.delete(cacheKey);
      fetchedAt.set(cacheKey, Date.now());
    });

  inflight.set(cacheKey, request);
  return request;
};
